import { Box, Button } from "@mui/material";
import { ReactComponent as Add } from "assets/Add.svg";
import ThemeContext from "components/app/Context";
import CustomButton from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import { useTranslate } from "hooks/useTranslate";
import React, { useContext } from "react";
import { useAppDispatch } from "redux/hooks";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { checkUserAccess } from "utils/CommonFunctions";
import Typography from "../../../common/Typography";
import AddSectionForm from "./Form";

interface Props {
  label: string;
  accessType?: string;
}
export default function AddNewSection(props: any) {
  const { label, accessType } = props;
  const [openDialog, setOpenDialog] = React.useState(Boolean);
  const formRef = React.useRef<any>(null);
  const { isMobileScreen } = useContext(ThemeContext);
  const restrictAccess = accessType && !checkUserAccess(accessType);
  const dispatch = useAppDispatch();
  const translate = useTranslate();

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const formSubmit = () => {
    formRef?.current?.submitForm();
  };
  const disabledLook = restrictAccess
    ? {
        cursor: "default",
        opacity: "0.35"
      }
    : {};

  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        backgroundColor: colors.Blue.Blue100,
        color: tokens.Text.General.Color,
        alignItems: "center",
        justifyContent: "center",
        height: "80px",
        marginBottom: "30px",
        gap: "1",
        ...disabledLook,
        ":hover": {
          backgroundColor: colors.Blue.Blue200
        }
      }}
    >
      <Button
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }
        }}
        onClick={() => {
          if (restrictAccess)
            dispatch(
              setFeedbackDetails({
                shouldShow: true,
                setState: setFeedbackDetails({ shouldShow: false }),
                message: translate("user.restrictAccess")
              })
            );
          else setOpenDialog(true);
        }}
      >
        <Box marginRight={"15px"}>
          <Add />
        </Box>
        <Typography variant="h5" showBold>
          {label}
        </Typography>
      </Button>

      {openDialog && (
        <DialogFormation
          title="Add new section"
          openDialog={openDialog}
          handleClose={handleCloseDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <CustomButton
                variant="secondary"
                label="Cancel"
                onClick={handleCloseDialog}
                width={isMobileScreen ? "50%" : "25%"}
                height="44px"
              />
              <CustomButton
                variant="primary"
                label="Save"
                onClick={formSubmit}
                width={isMobileScreen ? "50%" : "25%"}
                height="44px"
              />
            </div>
          }
        >
          <div className="horizontal-center">
            <AddSectionForm ref={formRef} item={{}} handleDialogClose={handleCloseDialog} />
          </div>
        </DialogFormation>
      )}
    </Box>
  );
}
